import ExpandFull from "./SVG/expand-full.svg?react";

const ExpandFullIcon = () => {
  return <ExpandFull />;
};

export default ExpandFullIcon;
